<template>
    <section>
        <div class="row progress" style="padding:0;margin:0;width:100vw;position:fixed;top:0;left:0" >
            <div class="indeterminate"></div>
        </div>
        <navigation></navigation>
        <div class="row col s12 m4">
            <ul class="collection with-header">
                <li class="collection-header">
                    <span style="font-size:x-large"><b>Advertisements</b></span>
                    <a class="btn-flat secondary-content" @click="saveOrder"><i class="material-icons" >save</i></a>
                    <a class="btn-flat secondary-content" @click="$router.push({name:'new-ad'})"><i class="material-icons" >cloud_upload</i></a>
                </li>
                <draggable v-model="ads">
                    <li v-for="ad in ads" :key="ad.id" class="collection-item avatar">
                        <i class="material-icons circle" :class="{green:ad.type==='picture',red:ad.type==='video'}">{{ad.type==="picture"?'photo':'play_arrow'}}</i>
                        <b>{{ad.label?ad.label:ad.filename}}</b>
                        <span v-if="ad.txt"><br>{{ad.txt}}</span>
                        <br>{{ad.points?ad.points:"No"}} Points
                        <a class="btn-flat secondary-content" @click="$router.push({name:'new-ad',params: { id: ad.id}})"><i class="material-icons">chevron_right</i></a>
                    </li>
                </draggable>
            </ul>
        </div>
    </section>
</template>

<script>
import navigation from "@/components/NavBar.vue";
import firebase from "firebase";
import draggable from 'vuedraggable'

export default {
    data() {
        return {
            ads:[],
            todos: [],
            todo: {
                title: ""
            }
        };
    },
    created() {
        this.getTodos();
    },
    components: { navigation, draggable},
    methods: {
        sort(a,b){
            if(a.priority && b.priority){
                return b.priority-a.priority;
            } else if(a.priority){
                return -1;
            } else if(b.priority){
                return 1;
            } else {
                return 0;
            }
        },
        saveOrder(){
            let batch = this.$firebase.firestore().batch();
            let size = this.ads.length;
            let timestamp = new Date().getTime();
            this.ads.forEach((el,index)=>{
                el.priority = size-index-1;
                el.timestamp = timestamp;
                let ref = this.$firebase.firestore().doc('ads/'+el.id);
                batch.update(ref,el);
            })
            this.$$(".progress").show();
            batch.commit().then(()=>{
                this.$M.toast({html:"Ads priority order saved"})
                this.$$(".progress").hide();
            }).catch(error=>{
                this.$M.toast({html:error.message})
                this.$$(".progress").hide();
            })
        },
        addTodo() {
            firebase
                .firestore()
                .collection("users")
                .doc(firebase.auth().currentUser.uid)
                .collection("todos")
                .add({
                    title: this.todo.title,
                    createdAt: new Date(),
                    isCompleted: false
                });
        },
        async getTodos() {
            var todosRef = await firebase
                .firestore()
                .collection("ads");
            todosRef.onSnapshot(snap => {
                this.todos = [];
                snap.forEach(doc => {
                    var todo = doc.data();
                    this.ads.push(todo);
                });
                this.$$(".progress").hide();
            });
        },
        updateTodoItem(docId, e) {
            var isChecked = e.target.checked;
            firebase
                .firestore()
                .collection("users")
                .doc(firebase.auth().currentUser.uid)
                .collection("todos")
                .doc(docId)
                .update({
                    isCompleted: isChecked
                });
        },
        deleteToDo(docId) {
            firebase
                .firestore()
                .collection("users")
                .doc(firebase.auth().currentUser.uid)
                .collection("todos")
                .doc(docId)
                .delete();
        }
    },
    filters:{
        capitalize(string){
            return string.substring(0,1).toUpperCase()+string.substring(1);
        }
    }
};
</script>

<style>
.fade {
    opacity: 0.4 !important;
}
li {
    font-size: 1.3em;
}
.collection.with-header {
    max-width: 500px;
    margin: 0 auto;
}
.deleteIcon {
    margin-right: 10px;
    cursor: pointer;
}
.deleteIcon:hover {
    opacity: 0.5;
}
</style>

